import { Outlet } from "react-router";

const StaffCalendarComponentIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default StaffCalendarComponentIndex;
